import React from 'react';

const EmbeddedNotFound = () => (
  <div className="container pt-5">
    <div className="row col-12 pt-5 pb-3">
      <div className="col-12 text-center">
        <h1>Error 404</h1>
      </div>
    </div>
    <div className="row col-12 pb-3">
      <div className="col-12 text-center">
        <h2>Publication not found</h2>
      </div>
    </div>
  </div>
);

export default EmbeddedNotFound;
